import React, { Component } from "react";

class Steps extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="steps-con">
          <h1>{this.props.step}</h1>
          <div className="step-icon">
            <div className="icon ste">
              <img src={this.props.imgsrc} alt="deafult" />
            </div>
            <div className={this.props.className}>{this.props.title}</div>
          </div>
          <p>{this.props.text}</p>
        </div>
      </>
    );
  }
}

export default Steps;
